import { all } from 'redux-saga/effects'
import { loginFlow } from './loginFlow'
import devicesPageSaga from './devicesPage.saga'

export default function* rootSaga() {
  yield all([loginFlow(), devicesPageSaga()])
}
